import ApiService from '@/core/services/api.service'
// import { cmdUrl } from '@/utils/apiUrl';

/**
 * Service for handling transaction-by-store report API calls
 */
export default {
  /**
   * Fetch transaction data by store with pagination and filtering
   * @param {Object} params - Filter parameters
   * @returns {Promise} - Promise with the response data
   */
  fetchTransactionsByStore(params) {
    return ApiService.query('/v1/reports/accounting-stores', { params })
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching transactions by store:', error)
        throw error
      })
  },

  /**
   * Fetch all stores
   * @returns {Promise} - Promise with the store data
   */
  fetchStores() {
    return ApiService.get('/stores/getStores')
      .then((response) => response.data.data)
      .catch((error) => {
        console.error('Error fetching stores:', error)
        throw error
      })
  },

  /**
   * Fetch stores available to the current user (cùng logic @/view/mixins/api-common.mixins.js fetchStoreByUser)
   * @returns {Promise<{ stores: Array, currentStoreId: number|null, currentStoreName: string, currentStoreShortName: string }>}
   */
  fetchStoresByUser() {
    return ApiService.get(`v1/stores/get-by-user`)
      .then(({ data }) => {
        const stores = data.data.stores || []
        const currentStore = stores.find(
          (store) => store.id === data.data.storeId,
        )
        return {
          stores,
          currentStoreId: currentStore?.id || null,
          currentStoreName: currentStore?.name || '',
          currentStoreShortName: currentStore?.shortName || '',
        }
      })
      .catch((error) => {
        console.error('Error fetching stores by user:', error)
        throw error
      })
  },
}
